export type WidgetContext = 'scanner' | 'screener';

export type AddRecentlyUsedIndicatorAction = {
    type: 'recentlyUsedIndicators::add';
    context: WidgetContext;
    indicatorId: string;
};

export type LoadRecentlyUsedIndicatorsAction = {
    type: 'recentlyUsedIndicators::load';
    scanner: string[];
    screener: string[];
};

export const addRecentlyUsedIndicator = (
    context: WidgetContext,
    indicatorId: string,
): AddRecentlyUsedIndicatorAction => ({
    type: 'recentlyUsedIndicators::add',
    context,
    indicatorId,
});

export const loadRecentlyUsedIndicators = (
    scanner: string[],
    screener: string[],
): LoadRecentlyUsedIndicatorsAction => ({
    type: 'recentlyUsedIndicators::load',
    scanner,
    screener,
});

export type RecentlyUsedIndicatorsAction = AddRecentlyUsedIndicatorAction | LoadRecentlyUsedIndicatorsAction;
